import { render } from "./MainGlobal.vue?vue&type=template&id=37de39d6"
import script from "./MainGlobal.vue?vue&type=script&lang=js"
export * from "./MainGlobal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__